import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=d014b05a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=d014b05a&prod&lang=css"
import style1 from "./Footer.vue?vue&type=style&index=1&id=d014b05a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d014b05a",
  null
  
)

export default component.exports